import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { BizzCustomersService } from 'src/app/_business-dashboard/_services/bizz-customers.service';
import { SignupService } from 'src/app/_services/signup.service';
import { SubscriptionPlanService } from 'src/app/_services/subscription-plan.service';
import { CurrentPlanGeneralInformation } from 'src/app/_models/subscription-management/current-plan-general-info';
import {
  PlanInfo,
  UserSubscriptionDetail,
} from 'src/app/_models/subscription-management/user-subscription-info';

@Component({
  selector: 'app-bizz-customer-hardware-details',
  templateUrl: './bizz-customer-hardware-details.component.html',
  styleUrls: ['./bizz-customer-hardware-details.component.scss']
})
export class BizzCustomerHardwareDetailsComponent implements OnInit {
  localItem: any = ''
  hardwareObj: any = ''
  localObj: any = ''

  stateOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ]

  invoiceDetail: any = []
  productsDetail: any = []
  hardwaredetails: any = []
  currentPlanSubscription = <UserSubscriptionDetail>{};
  loadingContent: boolean = false;
  dataList: any = [];
  totalRecords: number = 0;
  planPricePerMonth: number = 0;
  basePlanPrice: number = 0;
  costHeading: string = "";
  userCurrentPlan = <PlanInfo>{};
  currentPlanGeneralInformation: CurrentPlanGeneralInformation[] = [];
  subscribedPackages: any[] = [];

  constructor(
    public _bizzCustomerService: BizzCustomersService,
    public _signup: SignupService,
    public _getSubPlanInvoice: SubscriptionPlanService,
  ) { }

  /** Hardware catalog id -> title, from the same GetHardwarePackagesv2 endpoint the customer's
   *  own self-service billing page shops against (see BillingAndPlansComponent.loadHardwareCatalog())
   *  — needed because hardwarePkg line items only carry a packageId, not a display name. */
  private hardwareCatalogNames = new Map<string, string>();

  ngOnInit(): void {
    this.loadHardwareCatalog();
    this.buildHardwareObj();
  }

  private loadHardwareCatalog(): void {
    this._signup.getHardwarePlanListv2().pipe(
      timeout(10000),
      catchError(() => of(null)),
    ).subscribe((res: any) => {
      if (!res?.success || !Array.isArray(res.data)) return;
      const map = new Map<string, string>();
      for (const group of res.data) {
        for (const item of (Array.isArray(group?.items) ? group.items : [])) {
          if (item?.id != null) map.set(String(item.id), item.title);
        }
      }
      this.hardwareCatalogNames = map;
      this.buildHardwareObj();
    });
  }

  /** hardwarePkg (top-level on the admin GetReport row) is the real source of purchased hardware
   *  — activeItem.currentSubscription.subscribedPackagesV2 is a report-summary projection that's
   *  empty for accounts whose hardware purchase isn't reflected there (confirmed: an account with
   *  3 real hardwarePkg line items had an empty subscribedPackagesV2). Falls back to
   *  subscribedPackagesV2 for any report shape that still nests hardware there instead. */
  private buildHardwareObj(): void {
    const activeItem = this._bizzCustomerService?.activeItem;
    const hardwarePkg = activeItem?.hardwarePkg ?? activeItem?.HardwarePkg;
    const subscribedPackagesV2 = activeItem?.currentSubscription?.subscribedPackagesV2;

    const packageList: any[] = Array.isArray(hardwarePkg)
      ? hardwarePkg
      : (Array.isArray(subscribedPackagesV2) ? subscribedPackagesV2.filter((f: any) => !f?.reOccurring) : []);

    this.hardwareObj = packageList.map((item: any) => {
      const packageId = String(item?.packageId ?? item?.PackageId ?? '');
      const totalPrice = Number(item?.totalPrice) || 0;
      const taxAmount = Number(item?.taxAmount) || 0;
      return {
        ...item,
        name: item?.name || this.hardwareCatalogNames.get(packageId) || packageId,
        grandPrice: totalPrice + taxAmount,
      };
    });
  }
}
